/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

import styled from 'styled-components';

// import { IFooterCategoryViewProps } from '@msdyn365-commerce-modules/footer/src/modules/footer-category/./footer-category';
import { IFooterCategoryViewProps } from './IFooterCategoryConfig';

const Division = styled.hr`
    margin-bottom: 61px;
`;

export const FooterCategoryView: React.FC<IFooterCategoryViewProps> = props => {
    const { categories, FooterList, FooterListItem, data } = props;
    const policies = data.policy.result;

    if (!categories || categories.length === 0) {
        props.context.telemetry.error('Footer content is empty, module wont render');
        return null;
    }

    let privacyPolicy: any;
    let salesAndRefundPolicy: any;
    let termsOfUse: any;

    policies?.map(policy => {
        if (policy.Id === 5637145327) {
            privacyPolicy = policy;
        }
        if (policy.Id === 5637144576) {
            salesAndRefundPolicy = policy;
        }
        if (policy.Id === 5637145326) {
            termsOfUse = policy;
        }
    });

    return (
        <Module {...FooterList}>
            {categories.map((category: ReactNode, index: number) => {
                return (
                    <Node {...FooterListItem} key={index}>
                        {category}
                    </Node>
                );
            })}
            <a style={{ paddingRight: '14px' }} href={salesAndRefundPolicy?.URL}>
                {salesAndRefundPolicy?.DESCRIPTION}
            </a>
            <Division />
            <a style={{ paddingRight: '14px' }} href={termsOfUse?.URL}>
                {termsOfUse?.DESCRIPTION}
            </a>
            <a style={{ paddingRight: '14px' }} href={privacyPolicy?.URL}>
                {privacyPolicy?.DESCRIPTION}
            </a>
            <a
                style={{ paddingRight: '14px' }}
                id='teconsent'
                // @ts-ignore
                class='footershortcuts truste_caIcon_display'
                consent='undefined'
                aria-label='Open Cookie Preferences Modal'
                role='complementary'
            >
                <script
                    // @ts-ignore
                    async='async'
                    type='text/javascript'
                    crossorigin=''
                    importance='high'
                    src='https://consent.trustarc.com/asset/notice.js/v/v1.7-940'
                ></script>
                <a
                    role='link'
                    id='icon-id028615814013070495'
                    // @ts-ignore
                    tabindex='0'
                    lang='en'
                    aria-label='Cookie Preferences'
                    class='truste_cursor_pointer'
                >
                    Cookie Preferences
                </a>
            </a>
            <div>© 2024 by Intellectual Reserve, Inc. All rights reserved.</div>
        </Module>
    );
};

export default FooterCategoryView;
